import services from './services';
import {
	lg,
	cloneDeep,
	util,
	isCorrectVal,
	isDate
} from 'utils';
import NProgress from 'nprogress';
import addEmployeeDialog from './components/addEmployeeDialog/index.vue'
import setEmployeeArea from "./components/setEmployeeArea/index.vue";
export default {
	mixins: [services],
	components: {
		addEmployeeDialog,
		setEmployeeArea
	},
	data() {
		return {
			loading: false,
			lists: [],
			pageIndex: 1,
			pageSize: 10,
			totalSize: '',
			pageSizes: [10, 20, 50],
			query: this.getFormData(),
			departmentList: []

		}
	},
	methods: {
		getFormData() {
			return cloneDeep({
				Customer: "",
				Tel: "",
				Provinces_id: "",
				BuessionPartId: ""
			});
		},
		//离职
		handleQuit(index, row) {
			this.$confirm('确认该员工是否已离职？', '提示', {}).then(() => {
				this.AgentEmployeeQuit(row.Id)
			})
		},
		// 复职
		handleIn(index, row) {
			this.AgentEmployeeQuit(row.Id, 2)
		},
		clearIMEI(row) {
			this.$confirm('清除IMEI, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.clearIMEIService(row.Id);
			}).catch(() => {});
		},
		handleAll(index, row) {
			this.ModifyAgentAllEx(row.Id)
		},
		//修改
		handleEdit(index, row) {
			console.log(row)
			this.$refs.refSetEmployeeArea.show({
				Id: row.Id,
				CustomerId: row.CustomerId
			})
		},
		//添加地推业务员
		addFn() {
			this.$refs.refsEmployee.show({
				title: "添加地推业务员"
			});
		},
		//查询
		onQuerySubmit: function () {
			this.pageIndex = 1;
			this.getList();
		},
		// 重置
		onQueryClean: function () {
			this.query = this.getFormData();
			this.getList();
		},
		//查询功能
		handleSizeChange: function (val) {
			this.pageSize = val;
			this.getList();
		},
		handleCurrentChange: function (val) {
			this.pageIndex = val;
			this.getList();
		}
	},
	computed: {
		provinceList() {
			return this.$store.state.allProvince
		}
	},
	created() {
		this.getList();
		

	},
}


// WEBPACK FOOTER //
// ./src/pages/Agent/AddEmployee/vm.js